import React from "react";
import "../styles/theTeam.css"


const Partners: React.FC = () => {
    return (
        <>
            <section
                className="w-full bg-gradient-to-b from-[#201647] to-[#A574BFCC] py-20">

                <p className="pb-10 "></p>
            </section>
            <section className="bg-[#A574BFCC] flex flex-col justify-center items-center " id="partners">
                <p className="text-9xl text-white">Our Partners</p>


                <div className="grid grid-cols-7 grid-rows-3 gap-2 m-4 min-w-[40%] p-16 pb-10 min-h-auto">
                    <div
                        className="col-start-1 row-start-1 col-span-3 row-span-3  bg-gray-300 rounded-md ">
                        <img className="min-w-full min-h-full" src="/images/rgu.jpeg" />
                    </div>
                    <div
                        className="col-start-5 row-start-1 col-span-3 row-span-3 bg-gray-300 rounded-md">
                        <img className="min-w-full min-h-full" src="/images/appolo.jpeg" />
                    </div>

                </div>

                    <div className="text-white py-20 text-[30rem] flex flex-col justify-center items-center">

                        <p className="mt-6 max-w-4xl text-4xl text-center leading-relaxed" >
                            RGU Motorsport is proud to work alongside a range of industry partners
                            who support our mission to design, build, and race competitive student
                            race cars. Their expertise, resources, and guidance help us push the
                            boundaries of engineering and innovation each season.
                        </p>

                        <p className="mt-6 max-w-4xl text-4xl text-center leading-relaxed">
                            Through these partnerships, our team gains valuable real-world
                            experience while developing the skills needed for the future of
                            motorsport and engineering.
                        </p>


                        <a
                            href="mailto:rgu-motorsport@rguunion.co.uk"
                            className="button button--nina  hover:bg-[#252153] text-gray-300 hover:text-white relative block focus:outline-none border-2 border-solid rounded-2xl text-sm text-center font-semibold uppercase tracking-widest overflow-hidden"
                            data-text="Contact Us"
                        >
                            <span className="align-middle">C</span>
                            <span className="align-middle">o</span>
                            <span className="align-middle">n</span>
                            <span className="align-middle">t</span>
                            <span className="align-middle">a</span>
                            <span className="align-middle">c</span>
                            <span className="align-middle">t</span>
                            <span className="align-middle">&nbsp;</span>
                            <span className="align-middle">U</span>
                            <span className="align-middle">s</span>
                        </a>

                    </div>


            </section>
        </>
    );
};

export default Partners;
